var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.ready ? _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_vm.member._id ? _c('span', [_vm._v("회원상세")]) : _c('span', [_vm._v("회원등록")])]), _c('console-body', [_c('v-row', [_c('v-col', {
    staticClass: "pr-md-1",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1",
    attrs: {
      "label": "아이디",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.username,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "username", $$v);
      },
      expression: "member.username"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-password-field', {
    staticClass: "mx-1",
    attrs: {
      "label": "비밀번호",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.password,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "password", $$v);
      },
      expression: "member.password"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "이름",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.name,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "name", $$v);
      },
      expression: "member.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  })], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "연락처",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "phone", $$v);
      },
      expression: "member.phone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "이메일",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.email,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "email", $$v);
      },
      expression: "member.email"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "우편번호",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.member.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "postcode", $$v);
      },
      expression: "member.postcode"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "기본주소",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.member.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "address1", $$v);
      },
      expression: "member.address1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "상세주소",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "address2", $$v);
      },
      expression: "member.address2"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "items": _vm.levels,
      "item-text": "name",
      "item-value": "code",
      "label": "회원등급",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.levelCode,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "levelCode", $$v);
      },
      expression: "member.levelCode"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "items": _vm.riskManagement.giftcard.levels,
      "item-text": "text",
      "item-value": "value",
      "label": "교환소등급",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.riskManagement.giftcard.level,
      callback: function callback($$v) {
        _vm.$set(_vm.member.riskManagement.giftcard, "level", $$v);
      },
      expression: "member.riskManagement.giftcard.level"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "label": "CI 값",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.member.ci,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "ci", $$v);
      },
      expression: "member.ci"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pl-md-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mx-1 mt-3 mt-md-0"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("로그인 실패횟수 (" + _vm._s(_vm.member.loginFailedCount[_vm.$dayjs().format("YYYY-MM-DD")] || 0) + "/5)")]), _c('v-spacer'), _c('v-icon', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "size": "20"
    },
    on: {
      "click": function click($event) {
        _vm.member.loginFailedCount = new Map();
      }
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("자동차단여부 (차단안함/차단)")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.member.isAutoBlock,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "isAutoBlock", $$v);
      },
      expression: "member.isAutoBlock"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("관리자차단여부 (차단안함/차단)")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.member.isBlock,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "isBlock", $$v);
      },
      expression: "member.isBlock"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("휴면여부 (휴면안함/휴면)")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.member.isDormancy,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "isDormancy", $$v);
      },
      expression: "member.isDormancy"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("SMS 수신여부 (수신안함/수신)")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.member.smsEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "smsEnabled", $$v);
      },
      expression: "member.smsEnabled"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("Email 수신여부 (수신안함/수신)")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.member.emailEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "emailEnabled", $$v);
      },
      expression: "member.emailEnabled"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("관리자 메모")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.member.note,
      callback: function callback($$v) {
        _vm.$set(_vm.member, "note", $$v);
      },
      expression: "member.note"
    }
  })], 1)], 1), _c('purchase-list')], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "input": function input(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.member.postcode = postcode;
        _vm.member.address1 = address;
      }
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }